<template>
  <div>
    <SectionsHeroSection
      :filters="filters"
      @update:filters="updateFilters"
      @open-filters="showFilters = true"
    />
    <TripFilters
      v-model="showFilters"
      :filters="filters"
      :min-price="minPrice"
      :max-price="maxPrice"
      :min-days="minDays"
      :max-days="maxDays"
      @apply="applyFilters"
    />
    <SectionsGTSlider class="my-10" :filters="filters" />
    <SectionsGTContinent />
    <SectionsMonthlyDrawBanner />
    <div class="container mt-6 mb-20">
      <NuxtImg
        src="Rectangle 4520.svg"
        class="w-full shadow-[0px_0px_10.4px_3px_#00000040]"
        alt=""
      />
    </div>
    <SectionsGTMonth class="mb-12" />
    <SectionsBLTours class="mb-10" />
    <SectionsOurBrandAmbassadors class="mb-5" />
    <SectionsDownloadApp />
    <SectionsOurAchievements />
    <!-- <SectionsReviewsTestimonials class="mb-8" /> -->
    <div class="container mb-9">
      <SectionsOurPartners />
      <SectionsOurCompanies />
      <NuxtImg
        src="Rectangle 4521.svg"
        class="w-full my-9 shadow-[0px_0px_10.4px_3px_#00000040]"
        alt=""
      />
      <SectionsBlog />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TripFilters } from "~/types/filter";

const { t } = useI18n();
const BaseUrl = inject("BaseUrl") as string;

const showFilters = ref(false);
const filters = ref<TripFilters>({});
const minPrice = ref(0);
const maxPrice = ref(10000);
const minDays = ref(1);
const maxDays = ref(30);

// Helper function to check if trip is still joinable (last_join_date hasn't passed)

// Fetch trips to calculate price and days ranges
async function calculateRanges() {
  try {
    const { data } = await useAuthFetch<Api>(`${BaseUrl}/trips`);
    const allTrips = (data.value?.data.trips as Trip[]) || [];
    const trips = allTrips;
    
    if (trips.length > 0) {
      let minP = Infinity;
      let maxP = 0;
      let minD = 999;
      let maxD = 0;

      trips.forEach((trip) => {
        const singlePrice = parseFloat(trip.single_price) || 0;
        const sharePrice = parseFloat(trip.sharing_price) || 0;
        const tripMinPrice = Math.min(singlePrice, sharePrice);
        const tripMaxPrice = Math.max(singlePrice, sharePrice);

        if (tripMinPrice > 0 && tripMinPrice < minP) minP = tripMinPrice;
        if (tripMaxPrice > maxP) maxP = tripMaxPrice;

        const days = trip.number_of_days || 0;
        if (days > 0 && days < minD) minD = days;
        if (days > maxD) maxD = days;
      });

      minPrice.value = minP === Infinity ? 0 : minP;
      maxPrice.value = maxP || 10000;
      minDays.value = minD === 999 ? 1 : minD;
      maxDays.value = maxD || 30;
    }
  } catch (error) {
    console.error("Error calculating ranges:", error);
  }
}

function updateFilters(newFilters: TripFilters) {
  filters.value = newFilters;
}

function applyFilters(newFilters: TripFilters) {
  filters.value = newFilters;
  // Trigger refresh of trip components
  // Components will watch filters and refetch
}

// Calculate ranges on mount
onMounted(() => {
  calculateRanges();
});

useSeoMeta({
  title: t("home.seo.title"),
  description: t("home.seo.description"),
  ogTitle: t("home.seo.title"),
  ogDescription: t("home.seo.description"),
  ogImage: "/favicon.ico",
  ogUrl: "[og:url]",
  twitterTitle: t("home.seo.title"),
  twitterDescription: t("home.seo.description"),
  twitterImage: "/favicon.ico",
  twitterCard: "summary",
});
</script>
